import Vue from 'vue'
import Vuex from 'vuex'
import authentication from "./modules/authentication";
import settings from "./modules/settings";
import governingBodies from "./modules/governingBodies";
import features from './modules/features';
import hcpcPortal from './modules/hcpc-portal';
import VuexPersistence from "vuex-persist";
import intercom from './modules/intercom';
import userProfile from './modules/userProfile';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    key: 'data',
    storage: window.localStorage,
    modules: ['authentication', 'settings', 'features', 'hcpcPortal', 'intercom', 'userProfile']
});

export default new Vuex.Store({
    modules: {
        authentication,
        settings,
        governingBodies,
        features,
        hcpcPortal,
        intercom,
        userProfile
    },
    state: {

    },
    mutations: {

    },
    actions: {

    },
    plugins: [vuexLocal.plugin]
})
